import { jsx as _jsx } from "react/jsx-runtime";
import { ColorScope } from './ColorScope';
export function renderColorScope(component, index, renderChildrenFunction) {
    const role = component?.properties?.role || '';
    return (_jsx(ColorScope, { role: role, children: renderChildrenFunction && renderChildrenFunction(component) }));
}
